import Proxy from "./Proxy"

class MarketingActionProxy extends Proxy {
  constructor(parameters = {}) {
    super("marketing-actions", parameters)
  }
}

export default MarketingActionProxy
